export default [
    {
        path: "/admin/hr/positions",
        name: "position",
        meta: { requiresAuth: true },
        component: () => import("@/pages/hr/position/index.vue")
    }
];
